export type OrderSortType =
  | "Expires"
  | "StartDate"
  | "DiscountType"
  | "UseType"
  | "MinimumSpend"
  | "Active"
  | "CodeType"
  | "UsedDate"
  | "Name";

export type IGroupHeaders = {
  [key in OrderSortType]: (val: string) => string;
};

export const groupHeaders: IGroupHeaders = {
  Expires: (groupName: string) => groupName,
  StartDate: (groupName: string) => groupName,
  DiscountType: (groupName: string) =>
    groupName === "Percent" ? "Percentage" : "Fixed Value",
  UseType: (groupName: string) =>
    groupName === "SingleUse"
      ? "Single Use"
      : groupName === "MultiUse"
      ? "Multi Use"
      : "Once Per User",
  MinimumSpend: (groupName: string) => groupName,
  Active: (groupName: string) => (!!groupName ? "Active" : "Archived"),
  CodeType: (groupName: string) => groupName,
  UsedDate: (groupName: string) => groupName,
  Name: (groupName: string) => groupName,
};
